import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import ConfirmationModal from "../../Components/Modal/Modal";
import { useLocation, Redirect } from "react-router-dom";
import Signifier from "../../Components/Signifier";
import DropdownComponent from "../../Components/Dropdown/DropdownComponent";
import {
  deleteEmailTemplate,
  editEmailTemplate,
} from "../../Services/API/EmailTemplateService";
import TinyEditor from "../../Components/TextEditor/TinyEditor";
import { Plugins } from "../../Components/TextEditor/Plugins";
import { Toolbar } from "../../Components/TextEditor/Toolbar";
import { Functions } from "../../Components/TextEditor/Functions";
import { StyledTextField } from "../../Components/TextField/TextField";

function EmailTemplateDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
    },
    subSection: {
      height: "30%",
      paddingTop: "20px",
    },
    subCardDelete: {
      [theme.breakpoints.down("sm")]: {
        justifyContent: "flex-start",
        backgroundColor: "transparent",
        boxShadow: "none",
        height: "auto",
      },
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      height: "100%",
      maxHeight: "75px",
      alignItems: "center",
      paddingTop: "5px",
      paddingBottom: "5px",
      paddingLeft: "20px",
      paddingRight: "20px",
      fontSize: "18px",
      flexFlow: "wrap",
      backgroundColor: "rgba(255,54,32,.4)",
    },
    subTitle: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    subTitleSection: {
      display: "flex",
      flexDirection: "column",
    },
    subInfo: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      color: "rgba(0,0,0,.6)",
      fontSize: "16px",
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const convertToString = (arr) => {
    var retVal = "";

    for (var i in arr) {
      if (i !== arr.length - 1) {
        retVal += arr[i].emailAddress + ";";
      }
    }

    return retVal;
  };

  let location = useLocation();
  const [showInputError, setShowInputError] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState(
    location.state === undefined ? "" : location.state.name
  );
  const [from, setFrom] = useState(
    location.state === undefined ? "" : location.state.from
  );
  const [fromName, setFromName] = useState(
    location.state === undefined ? "" : location.state.fromName
  );
  const [subject, setSubject] = useState(
    location.state === undefined ? "" : location.state.subject
  );
  const [htmlBody, setHtmlBody] = useState(
    location.state === undefined ? "" : location.state.body
  );
  const emailTypes =
    location.state === undefined ? "" : location.state.emailTypes;
  const [selectedEmailType, setSelectedEmailType] = useState("");
  const [to, setTo] = useState(
    convertToString(
      location.state === undefined
        ? ""
        : location.state.emailResumeDestinations
    )
  );
  const [processing, setProcessing] = useState(false);
  const [deleted, setDeleted] = useState(false);

  const subjectButtons = [
    { title: "User's First Name", val: "[[firstname]]" },
    { title: "User's Last Name", val: "[[lastname]]" },
    { title: "User's Email", val: "[[email]]" },
    { title: "Client Name", val: "[[clientname]]" },
    { title: "Start Day Of Current Week", val: "[[startcurrentweek]]" },
    { title: "End Day Of Current Week", val: "[[endcurrentweek]]" },
    { title: "Event Name", val: "[[eventname]]" },
    { title: "Event Start Date", val: "[[eventstartdate]]" },
    { title: "Event Start Time", val: "[[eventstarttime]]" },
    { title: "Job Title", val: "[[emailapplyjobtitle]]" },
  ];

  const checkAllEntered = () => {
    if (
      name === "" ||
      from === "" ||
      fromName === "" ||
      subject === "" ||
      htmlBody === ""
    ) {
      return false;
    }
    return true;
  };

  const createSendToArray = () => {
    var retVal = [];
    if (selectedEmailType === "Talent_Network_Uploaded_Resume" && to !== "") {
      var recipients = to.split(";");
      for (var i in recipients) {
        var newDestination = {
          ClientId: location.state === null ? "" : location.state.clientId,
          EmailAddress: recipients[i],
        };
        retVal.push(newDestination);
      }
    }

    return retVal;
  };

  const data = {
    Id: location.state === undefined ? "" : location.state.id,
    ClientId: location.state === undefined ? "" : location.state.clientId,
    EmailTemplateType: location.state === undefined ? "" : selectedEmailType.id,
    Name: name,
    Subject: subject,
    Body: htmlBody,
    From: from,
    FromName: fromName,
    EmailResumeDestinations: createSendToArray(),
  };

  const callAPI = (func, responseMessage) => {
    setProcessing(true);
    func.then((res) => {
      setShowSignifier(true);
      if (res) {
        setResponseMessage(responseMessage);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    });
  };

  const callDelete = async () => {
    await deleteEmailTemplate(location.state.id).then((response) => {
      if (response) {
        setDeleted(true);
        return true;
      }
    });
    return true;
  };

  useEffect(() => {
    if (location.state !== undefined) {
      for (var i in emailTypes) {
        if (emailTypes[i].name === location.state.emailTypeName) {
          setSelectedEmailType(emailTypes[i]);
        }
      }
    }
  }, [emailTypes, location.state]);

  if (location.state === undefined) {
    return <Redirect to="/emailtemplates" />;
  }

  if (deleted) {
    return <Redirect to="/emailtemplates" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Email Template</h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={6} item>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {showInputError && name === "" && (
                      <FormHelperText style={{ color: "red" }}>
                        Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid xs={12} sm={6} item>
                    <DropdownComponent
                      currValue={selectedEmailType}
                      items={emailTypes}
                      property="name"
                      title="Email Type"
                      handleChange={(value) => setSelectedEmailType(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="From"
                      label="From"
                      variant="standard"
                      fullWidth
                      required
                      value={from}
                      onChange={(e) => setFrom(e.target.value)}
                    />
                    {showInputError && from === "" && (
                      <FormHelperText style={{ color: "red" }}>
                        From Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="From Name"
                      label="From Name"
                      variant="standard"
                      fullWidth
                      required
                      value={fromName}
                      onChange={(e) => setFromName(e.target.value)}
                    />
                    {showInputError && fromName === "" && (
                      <FormHelperText color="error">
                        From Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  {selectedEmailType === "Talent_Network_Uploaded_Resume" ? (
                    <Grid item xs={12} sm={12}>
                      <StyledTextField
                        InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                        placeholder="To"
                        label="To ( ; delimited, if multiple)"
                        variant="standard"
                        fullWidth
                        value={to}
                        onChange={(e) => setTo(e.target.value)}
                      />
                    </Grid>
                  ) : null}
                  {subjectButtons.map((button, index) => (
                    <Grid item xs={3} sm={1}>
                      <Button
                        size="small"
                        style={{
                          width: "100%",
                          height: "70px",
                          marginTop: "20px",
                          fontSize: "11px",
                          lineHeight: "14px",
                        }}
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={() => setSubject(subject + button.val)}
                      >
                        {button.title}
                      </Button>
                    </Grid>
                  ))}
                  <Grid item xs={12} sm={12}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Subject"
                      label="Subject"
                      variant="standard"
                      fullWidth
                      required
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                    {showInputError && subject === "" && (
                      <FormHelperText color="error">
                        Subject Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TinyEditor
                      value={htmlBody}
                      setValue={setHtmlBody}
                      plugins={Plugins}
                      toolbar={Toolbar}
                      functions={Functions}
                    />
                    {showInputError && htmlBody === "" && (
                      <FormHelperText color="error">
                        Body Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        checkAllEntered()
                          ? callAPI(editEmailTemplate(data), "Template Saved")
                          : setShowInputError(true)
                      }
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <div className={classes.sensitiveSection}>
              <Grid
                item
                xs={12}
                sm={12}
                container
                justifyContent="space-between"
              >
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpenModal(true)}
                >
                  Delete Template
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <ConfirmationModal
          question="Are you want to delete Template?"
          func={() => callAPI(callDelete(), "Template Deleted")}
          closeModal={() => setOpenModal(false)}
          processing={processing}
        />
      </Dialog>
    </>
  );
}

export default EmailTemplateDetailed;
